import { UserServiceType, UserServiceResponseInterface } from './userServiceTypes'
import axios from 'axios'
import { ReduxAction } from '../../reducers/reducerType'
import { ServiceError } from '@bt-react/constants'
import get from 'lodash/get'
import user from '@bt-react/libs/user'

export const fetchUserDataSuccess = (data: UserServiceResponseInterface): ReduxAction<UserServiceResponseInterface> =>
  ({ type: UserServiceType.FETCH_USER_DATA_SUCCESS, payload: data })

export const fetchUserDataError = (error): ReduxAction =>
  ({ type: UserServiceType.FETCH_USER_DATA_ERROR, payload: error })

export const fetchUserData = (BTSESSION?:string) => async (dispatch, getState): Promise<void> => {

  dispatch({ type: UserServiceType.FETCH_USER_DATA })

  const { config: { host } } = getState()

  try {
    const headers: {
      Accept: string,
      Cookie?: string
    } = {
      Accept: 'application/json'
    }

    if (BTSESSION) {
      headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
    }
    const { data } = await axios.get(`${host}/service/user/session/user`, {
      headers
    })

    dispatch(fetchUserDataSuccess(data))

  }
  catch (e) {
    const status = get(e, 'request.status', 500)
    let errorMessage = {}

    switch (status) {

      case 500:
        errorMessage = {
          code: 500,
          message: ServiceError.NETWORK_ERROR
        }
        break
      default:
        errorMessage = {
          code: e.request.status,
          message: e.message
        }

    }

    dispatch(fetchUserDataError(errorMessage))

  }

}

export const submitLoginForm = (jwt) => async (dispatch, getState) => {

  dispatch({ type: UserServiceType.SUBMIT_LOGIN_FORM })

  let status
  try {

    const response = await user.authRequest(jwt)

    status = response.status

  }
  catch (e) {

    dispatch({ type: UserServiceType.SUBMIT_LOGIN_FORM_FAILED, payload: e })

  }

  if (status === 204) {

    dispatch({ type: UserServiceType.SUBMIT_LOGIN_FORM_SUCCESS })

  }
  else {

    dispatch({ type: UserServiceType.SUBMIT_LOGIN_FORM_FAILED, payload: {message: 'Something went wrong...'} })

  }

}

export const loginErrorStatus = (e) => async (dispatch) => {
  dispatch({ type: UserServiceType.SUBMIT_LOGIN_FORM_FAILED, payload: e })
}

export const submitStatus = () => async (dispatch) => {
  dispatch({ type: UserServiceType.SUBMIT_LOGIN_FORM })
}
